import { render, staticRenderFns } from "./GoogleSso.vue?vue&type=template&id=12e8d02c&"
import script from "./GoogleSso.vue?vue&type=script&lang=js&"
export * from "./GoogleSso.vue?vue&type=script&lang=js&"
import style0 from "./GoogleSso.vue?vue&type=style&index=0&id=12e8d02c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports